export function readPublicEnvironment(name: string): string {
  const environment: unknown = import.meta.env;
  if (!environment || typeof environment !== 'object') return '';
  const value = (environment as Record<string, unknown>)[name];
  return typeof value === 'string' ? value.trim() : '';
}
